import { useState, useEffect } from "react";

const CustomFieldModal = ({
  isOpen,
  onClose,
  onSubmit,
  division: propDivision,
  isDivisionDisabled = true,
}) => {
  const [fieldLabel, setFieldLabel] = useState("");
  const [fieldType, setFieldType] = useState("");
  const [placeholder, setPlaceholder] = useState("");
  const [fieldOptions, setFieldOptions] = useState("");
  const [isRequired, setIsRequired] = useState("yes");
  const [division, setDivision] = useState(propDivision || ""); // Initialize with passed division

  const handleTypeChange = (e) => {
    setFieldType(e.target.value);
    setFieldOptions(""); // Reset options when type changes
    setPlaceholder(""); // Reset placeholder
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let payload = {
      field_label: fieldLabel,
      field_type: fieldType,
      placeholder:
        fieldType === "text" || fieldType === "date" ? placeholder : null,
      options:
        fieldType === "dropdown" ||
        fieldType === "radio" ||
        fieldType === "checkbox"
          ? fieldOptions
          : null,
      type: isRequired === "yes" ? "required" : "optional",
      target_model:
        division.toLowerCase() === "executive" ? "executive" : "buyerdetails",
      division: division,
      is_required: isRequired === "yes",
    };

    const success = await onSubmit(payload);

    if (success) {
      onClose(); // Close the modal on successful submission
    }
    setFieldLabel("");
    setFieldType("");
    setPlaceholder("");
    setFieldOptions("");
  };

  // Update division when propDivision changes
  useEffect(() => {
    if (propDivision) {
      setDivision(propDivision);
    }
  }, [propDivision]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white w-full h-fit max-w-2xl rounded-lg shadow-lg p-6">
        <div className='flex items-center justify-between mb-5'>
              <h1 className="text-xl text-gray-900 font-bold">Add Field</h1>
              <h1 onClick={onClose} className='text-xl text-gray-900 hover:text-red-600 cursor-pointer font-bold'>X</h1>
            </div>
        <form className="grid gap-4" onSubmit={handleSubmit}>
          {/* Field Name */}
          <div>
            <label className="block">Field Name</label>
            <input
              type="text"
              placeholder="Enter field name"
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none"
              value={fieldLabel}
              onChange={(e) => setFieldLabel(e.target.value)}
              required
            />
          </div>

          {/* Field Type */}
          <div>
            <label className="block">Field Type</label>
            <select
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none"
              value={fieldType}
              onChange={handleTypeChange}
              required
            >
              <option value="" disabled>
                Select Field Type
              </option>
              <option value="text">Text</option>
              <option value="radio">Radio</option>
              <option value="dropdown">Dropdown</option>
              <option value="checkbox">Checkbox</option>
              <option value="date">Date</option>
            </select>
          </div>

          {/* Options */}
          {(fieldType === "dropdown" ||
            fieldType === "radio" ||
            fieldType === "checkbox") && (
            <div>
              <label className="block">Options (comma-separated)</label>
              <textarea
                placeholder="Enter options separated by commas"
                className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none"
                value={fieldOptions}
                onChange={(e) => setFieldOptions(e.target.value)}
                required
              />
            </div>
          )}

          {/* Placeholder */}
          {(fieldType === "text" || fieldType === "date") && (
            <div>
              <label className="block">Placeholder</label>
              <input
                type="text"
                placeholder="Enter placeholder"
                className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none"
                value={placeholder}
                onChange={(e) => setPlaceholder(e.target.value)}
              />
            </div>
          )}

          {/* Required */}
          <div>
            <label className="block">Required</label>
            <select
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none"
              value={isRequired}
              onChange={(e) => setIsRequired(e.target.value)}
            >
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>

          {/* Division (as text input) */}
          <div>
            <label className="block">Division</label>
            <input
              type="text"
              value={division}
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none"
              onChange={(e) => setDivision(e.target.value)}
              disabled={isDivisionDisabled} // Disable based on the prop
            />
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <button
              type="button"
              className="bg-gray-300 text-black px-4 py-2 rounded-md"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded-md"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CustomFieldModal;
